/**
 * Client-side validation for the editable Guardian profile (audit P-18).
 *
 * Names: 1–64 characters after trimming (the Backend column is 64), with control
 * and format characters rejected. The Backend validates the same rules and is
 * the authority; this only keeps obviously bad input off the wire and gives
 * immediate feedback.
 */

// Unicode control (Cc) and format (Cf, e.g. zero-width / bidi overrides) chars.
const CONTROL_FORMAT = /[\p{Cc}\p{Cf}]/u;

export const NAME_MAX = 64;

/**
 * @param {unknown} value
 * @param {string} [label]
 * @returns {{ ok: boolean, value: string, error: (string|null) }} trimmed value + error.
 */
export function validateProfileName(value, label = 'Name') {
  const trimmed = (typeof value === 'string' ? value : '').trim();
  if (trimmed.length < 1) return { ok: false, value: trimmed, error: `${label} is required.` };
  if (trimmed.length > NAME_MAX) {
    return { ok: false, value: trimmed, error: `${label} must be ${NAME_MAX} characters or fewer.` };
  }
  if (CONTROL_FORMAT.test(trimmed)) {
    return { ok: false, value: trimmed, error: `${label} contains invalid characters.` };
  }
  return { ok: true, value: trimmed, error: null };
}
